import React from "react";

// Components
import ContentHeader from "./components/content-header";
import ContentBody from "./components/content-body";
import InfoHeader from "./components/info-header";
import ContentFooter from "./components/content-footer";
import ContentCard from "./components/content-card";
import ContentJMA from "./components/content-jma";
import ContentMA from "./components/content-ma";

// Ctx
import { TrainingProvider, useTrainingCtx } from "./useTraining";

const Training = () => {
  const { tab } = useTrainingCtx();
  
  const renderContent = () => {
    switch (tab) {
      case "ma":
        return <ContentMA />;
      case "jma":
        return <ContentJMA />;
      default:
        return <ContentCard />;
    }
  };
  
  return (
    <div className="w-[calc(100vw-193px)] ml-[193px] bg-[#D8D8D9]">
      <ContentHeader />
      <ContentBody>
        <InfoHeader />
        {renderContent()}
      </ContentBody>
      <ContentFooter />
    </div>
  );
};

export default function TrainingPage() {
  return (
    <TrainingProvider>
      <Training />
    </TrainingProvider>
  );
}
